import * as stylex from "@stylexjs/stylex";
import { useContentRect } from "../hooks";
import { layout } from "../materials/layout.stylex";
import { Trajectories } from "./lib/Trajectories/";
export function TrajectoriesChart(props) {
    const [ref, contentRect] = useContentRect();
    return <div ref={ref} {...stylex.props(layout.fullWidth)}>
      {contentRect.width > 0 && <Trajectories {...props} width={contentRect.width}/>}
    </div>;
}
